import React from 'react';
import HTMLFlipBook from 'react-pageflip';

export type PageTurningPreviewProps = {
  height: number;
  width: number;
  startPage: number;
  previews: string[];
  isSmallScreen: boolean;
};

const PageTurningPreview = ({
  height,
  width,
  startPage,
  previews,
  isSmallScreen,
}: PageTurningPreviewProps) => {
  return (
    <div className="shadow-lg">
      <HTMLFlipBook
        key={Number(isSmallScreen)}
        width={width}
        height={height}
        className={'!flex flex-1'}
        style={{}}
        startPage={startPage}
        size={'fixed'}
        minWidth={0}
        maxWidth={0}
        minHeight={0}
        maxHeight={0}
        drawShadow={false}
        flippingTime={1000}
        usePortrait={false}
        startZIndex={0}
        autoSize={true}
        maxShadowOpacity={0}
        showCover={true}
        mobileScrollSupport={false}
        clickEventForward={true}
        useMouseEvents={true}
        swipeDistance={0}
        showPageCorners={false}
        disableFlipByClick={false}
      >
        {previews
          ?.map((s: string, index: number) => {
            if (!s) {
              return null;
            }
            return <img src={s} alt={`Page ${index}`} key={index} className="object-cover" />;
          })
          .filter(i => i)}
      </HTMLFlipBook>
    </div>
  );
};

export default PageTurningPreview;
